import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { Brand } from '../models/Brand';

@Injectable({ providedIn: 'root' })

export class BrandService { 
  private _ENDPOINT = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/brands';   
  }
 
  getAll(): Observable<Array<Brand>> { 
    return this.http.get<Array<Brand>>(this._ENDPOINT + '');
  }

  getActiveBrands(): Observable<Array<Brand>> {
    return this.http.get<Array<Brand>>(this._ENDPOINT + '?isActive=true');
  }

  getInactiveBrands(): Observable<Array<Brand>> {
    return this.http.get<Array<Brand>>(this._ENDPOINT + '?isActive=false');
  }

  getMostRecent(): Observable<Array<Brand>> {
    return this.http.get<Array<Brand>>(this._ENDPOINT + '?isActive=true&total=5');
  }

  getAllMaster(): Observable<Array<Brand>> {
    return this.http.get<Array<Brand>>(this._ENDPOINT + '?isActive=true&brandId=0');
  } 
 
  getChildren(id: any): Observable<Array<Brand>> {
    return this.http.get<Array<Brand>>(this._ENDPOINT + `?isActive=true&brandId=${id}`);
  }
      
  getById(id: any): Observable<Brand> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<Brand>(url);
  }

  /** POST: add a new brand to the server */
  add(brand: Brand): Observable<Brand> {
    return this.http.post<Brand>(this._ENDPOINT, brand, this.httpOptions).pipe(
      tap((newBrand: Brand) => this.log('added brand w/ id=${newBrand.id}')),
      catchError(this.handleError<Brand>('add'))
    );
  }

  /** DELETE: delete the brand from the server */
  delete(brand: Brand | number): Observable<Brand> {
    const id = typeof brand === 'number' ? brand : brand.id;
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<Brand>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted brand id=${id}')),
      catchError(this.handleError<Brand>('delete'))
    );
  }

  /** PUT: update the brand on the server */
  update(id: number, brand: Brand): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, brand , this.httpOptions).pipe(
      tap(_ => this.log('updated brand id=${brand.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a BrandService message with the MessageService */
  private log(message: string) {
    this.messageService.add('BrandService: ${message}');
  }
}
